<section class=" p-5 center">
    <!-- <h4>Choose Your Adventure</h4> -->
    <div class="center" style="width: 90%; display: inline-block;">
      <div class="row justify-content-center">
   
        <div class="col-lg-3 col-md-6 col-sm-12 " style="min-width: 350px">
          <div class="card drop-shadow border-radius  pt-4 center mb-4" style="width: 333px; "> 
            <!-- <h5 class="card-title m-3">{{json | quote}}</h5> -->
            <h5 class="card-title m-3">Conventional 30 Yr Fixed</h5>
            <div class="row m-3">
              <div class="col center">
              
                <h6>Rate</h6>
               
                  <h4 class="center bold" style="font-weight: 900;">{{results?.mortech?.results[0].quote[0].quote_detail[0].$.rate}}%</h4>
                 
              </div>
              <div class="col center">
                
                <h6 class="center">APR</h6>
              
                  <h4 class="center bold" >{{results?.mortech?.results[0].quote[0].quote_detail[0].$.apr}}%</h4>
                
              </div>
          </div>
           
            <div>
             
              <hr class="center"style="border-bottom: 1pt solid rgb(235, 233, 233);width: 70%; text-align: center; display: inline-block;margin-top:0">
           
              <p class="small">Last updated: {{results?.mortech?.results[0].quote[0].$.lastUpdate  | amLocale:'en' | amDateFormat:'MMMM Do YYYY, h:mm:ss a'}}</p>
           
            </div>
          </div>
        </div>
      
     
      </div>

  </div>

  </section>
